<div class="parent-container" *ngIf="login_popup">
  <div class="auth-container modal-content" [ngClass]="isLoginMode ? 'login-container' : 'sign-up-container'">
    <span class="close-trigger">
      <img src="{{this.api.frontendAssetsUrl}}close (1).png" alt="close-trigger" class="close-icon"
        (click)="closepop()" />
    </span>

    <div class="form-content">
      <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabchange($event)">
        <!-- Login Form -->
        <mat-tab label="LOGIN">
          <form [formGroup]="AuthForm" (ngSubmit)="loginotp()">
            <div class="login_parent" *ngIf="!isForgotPassword && !isloginOtpVisible && !ispwdrest  ">
              <label>Username/Email</label>
              <mat-form-field appearance="outline" class="form-group">
                <input matInput id="username" formControlName="username" type="text"
                   />
                <!-- <mat-error *ngIf="getvalidationError('username')">{{
                  getvalidationError("username")
                  }}</mat-error> -->
              </mat-form-field>
              <button mat-raised-button color="primary" type="submit" *ngIf="!isForgotPassword"
                 class="login-button" [disabled]="isSubmitting">
                <span *ngIf="!isSubmitting">Login</span>
                <span *ngIf="isSubmitting">Please wait...</span>
                <mat-spinner *ngIf="isSubmitting" diameter="15" class="spinner"></mat-spinner>
              </button>
            </div>
            <div class="forgotpsd-container">
             

              <!-- --------is login otp form---------- -->

              <div *ngIf="isloginOtpVisible" class="OTP-container">
                <p class="otp_send">OTP Sent To : {{this.AuthForm.controls['username'].value}}</p>
                <div class="otp-input-container">

                  <label>Enter OTP</label>
                  <div class="otp-inputs">
                    <input #firstInput *ngFor="let otpField of otpFields; let i = index" matInput type="text" maxlength="1"  (paste)="onOtpPaste($event)"
                      [(ngModel)]="otpValues[i]" [ngModelOptions]="{ standalone: true }" (input)="onOtpInput($event, i)"
                      (keydown)="onOtpKeydown($event, i)" (keydown.enter)="verifyOtp()" class="otp-input {{i==0? 'first_input':''}}" />
                  </div>
                </div>
                <div class="error-container">
                  <span class="error-forgotpwd" *ngIf="isRequiredOTP">All fields are required.</span>
                  <span class="error-forgotpwd" *ngIf="containsnumber">OTP must be 6 digits.</span>
                </div>
                <button mat-raised-button color="primary" type="button" class="get_password" (click)="verifyOtp()"
                  [disabled]="!isOtpComplete()">
                  Verify OTP
                  <mat-spinner *ngIf="isSubmittingotp" diameter="15" class="spinner"></mat-spinner>
                </button>
                <div class="timer">
                  <a (click)="backtologin(false)" class="Back-to-login-otp" *ngIf="canResendOtp">Back to Login</a>
                  <p *ngIf="isTimerRunning" class="countdown">{{ countdown }}</p>
                  <p *ngIf="canResendOtp" (click)="sendOtp()" class="Resend">Resend OTP</p>
                </div>
              </div>
            </div>
          </form>
        </mat-tab>

        <mat-tab label="SIGN UP">
          <form [formGroup]="signupForm" *ngIf="!isOtpVisible" (ngSubmit)="tosendOtp()">
            <div *ngIf="!isLoginMode" class="form-sign-up">
              <div class="form-value">
                <label>Username</label>
                <mat-form-field appearance="outline" class="form-group">
                  <input matInput id="Username" formControlName="Username" type="text" />
                  <mat-error *ngIf="getvalidationError('Username')">{{
                    getvalidationError("Username")
                    }}</mat-error>
                </mat-form-field>
              </div>
              <div class="form-value">
                <label>Gender</label>
                <mat-form-field appearance="outline" class="form-group">
                  <mat-select id="gender" formControlName="gender" class="dsp-form-control"
                    (openedChange)="onMatSelectOpened($event)">
                    <mat-option *ngFor="let gender of genderOptions" [value]="gender._id">{{ gender.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-value">
                <label>First Name</label>
                <mat-form-field appearance="outline" class="form-group">
                  <input matInput id="Firstname" formControlName="Firstname" type="text" />
                  <mat-error *ngIf="getvalidationError('Firstname')">{{
                    getvalidationError("Firstname")
                    }}</mat-error>
                </mat-form-field>
              </div>
              <div class="form-value">
                <label>Last Name</label>
                <mat-form-field appearance="outline" class="form-group">
                  <input matInput id="lastName" formControlName="lastName" type="text" />
                  <mat-error *ngIf="getvalidationError('lastName')">{{
                    getvalidationError("lastName")
                    }}</mat-error>
                </mat-form-field>
              </div>
          
              <div class="form-value">
                <label>Email</label>
                <mat-form-field appearance="outline" class="form-group">
                  <input matInput id="email" formControlName="email" type="email" />
                  <mat-error *ngIf="getvalidationError('email')">{{
                    getvalidationError("email")
                    }}</mat-error>
                </mat-form-field>
              </div>
              <div class="form-value">
                <label>Confirm Email</label>
                <mat-form-field appearance="outline" class="form-group">
                  <input matInput id="confirmEmail" formControlName="confirmEmail" type="email" />
                  <mat-error *ngIf="getvalidationError('confirmEmail')">{{
                    getvalidationError("confirmEmail")
                    }}</mat-error>
                </mat-form-field>
              </div>

              <!-- Birth Date Selectors -->
              <div class="form-group dob">
                <label>Birth Date</label>
                <div class="date-selectors">
                  <mat-form-field appearance="outline">
                    <mat-label>Year</mat-label>
                    <mat-select formControlName="birthYear" class="dsp-form-control"
                      (openedChange)="onMatSelectOpened($event)">
                      <mat-option *ngFor="let year of birthYears" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Month</mat-label>
                    <mat-select formControlName="birthMonth" class="dsp-form-control"
                      (openedChange)="onMatSelectOpened($event)">
                      <mat-option *ngFor="let month of birthMonths" [value]="month.value">{{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Day</mat-label>
                    <mat-select formControlName="birthDay" class="dsp-form-control"
                      (openedChange)="onMatSelectOpened($event)">
                      <mat-option *ngFor="let day of birthDays" [value]="day">{{
                        day
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <button class="signup-button" color="primary" type="submit" 
                *ngIf="!isForgotPassword" [disabled]="signupForm.invalid">
                {{!isSubmittingSignup?'Sign Up':'Please wait...'}}
                <mat-spinner *ngIf="isSubmittingSignup" diameter="15" class="spinner"></mat-spinner>
              </button>
            </div>
          </form>

          <!-- -------otp form-------- -->

          <div *ngIf="isOtpVisible" class="OTP-container">
            <p class="otp_send">OTP Sent To : {{this.signupForm.controls['email'].value}}</p>
            <div class="otp-input-container">

              <label>Enter OTP</label>
              <div class="otp-inputs">
                <input #firstInput *ngFor="let otpField of otpFields; let i = index" matInput type="text" maxlength="1" (paste)="onOtpPaste($event)"
                  [(ngModel)]="otpValues[i]" [ngModelOptions]="{ standalone: true }" (input)="onOtpInput($event, i)"
                  (keydown)="onOtpKeydown($event, i)" (keydown.enter)="verifyRegOtp()" class="otp-input" />
              </div>
            </div>
            <div class="error-container">
              <span class="error-forgotpwd" *ngIf="isRequiredOTP">All fields are required.</span>
              <span class="error-forgotpwd" *ngIf="containsnumber">OTP must be 6 digits.</span>
            </div>
            <button mat-raised-button color="primary" type="button" class="get_password" (click)="verifyRegOtp()"
              [disabled]="!isOtpComplete()">
              Verify OTP
              <mat-spinner *ngIf="isSubmittingotp" diameter="15" class="spinner"></mat-spinner>
            </button>
            <div class="timer">
              <a (click)="backtoregister(false)" class="Back-to-login-otp" *ngIf="canResendOtp">Back to signup</a>
              <p *ngIf="isTimerRunning" class="countdown">{{ countdown }}</p>
              <p *ngIf="canResendOtp" (click)="tosendOtp()" class="Resend">Resend OTP</p>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>